import React from 'react'
import HeroSign from '../Component/MySignUp/HeroSign'
import Sign from '../Component/MySignUp/Sign'



const SignUp = () => {
    return (
        <>
        <HeroSign/>
        <Sign/>
    
        </>
    )
}

export default SignUp
